import { render, staticRenderFns } from "./DeleteSubCategory.vue?vue&type=template&id=c95d6ad4&scoped=true&"
import script from "./DeleteSubCategory.vue?vue&type=script&lang=ts&"
export * from "./DeleteSubCategory.vue?vue&type=script&lang=ts&"
import style0 from "./style.scss?vue&type=style&index=0&id=c95d6ad4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95d6ad4",
  null
  
)

export default component.exports